import { getOnePieceServerApi } from 'gql-ops';
import { User } from 'gql-ops/graph/__generated__/request';
import { useEffect, useState } from 'react';

export function useInviteCode(initialInviteCode = '') {
    const [inviteCode, setInviteCode] = useState(initialInviteCode);
    const [invalidMsg, setInvalidMsg] = useState('');
    const [inviter, setInviter] = useState<Partial<User> | null>(null);

    useEffect(() => {
        if (!inviteCode || inviteCode.length < 6) {
            setInviter(null);
            setInvalidMsg('');

            return;
        }

        getOnePieceServerApi()
            .queryUserByInviteCode({ inviteCode })
            .then((result) => {
                if (result?.queryUserByInviteCode) {
                    setInviter(result.queryUserByInviteCode);
                    setInvalidMsg('');
                    return;
                }

                setInvalidMsg('Invalid Invitation Code');
                setInviter(null);
            });
    }, [inviteCode]);

    return [inviteCode, setInviteCode, inviter, invalidMsg] as const;
}
